const body = {
    root: {
        backgroundColor: 'neptune-100',
        fontFamily: 'body'
    }
};

export default { body };
